import { Action } from '@ngrx/store';
import { DatesIntervalRequest, DatesInterval, SortInfo } from '../../global/interfaces';
import { TaxDetailsDataResponse, TaxDetailsRequestPayload } from './tax-details.models';

export enum ActionTypes {
    LOAD_TAX_DETAILS_DATES = '[TAX_DETAILS] Load TAX_DETAILS Dates Action',
    LOAD_TAX_DETAILS_DATES_SUCCESS = '[TAX_DETAILS] Load TAX_DETAILS Dates Success Action',
    LOAD_TAX_DETAILS_DATES_FAILED = '[TAX_DETAILS] Load TAX_DETAILS Dates Failed Action',
    SET_TAX_DETAILS_YEAR_FILTER = '[TAX_DETAILS] Set TAX_DETAILS Year Filter Action',
    SET_TAX_DETAILS_MONTH_FILTER = '[TAX_DETAILS] Set TAX_DETAILS Month Filter Action',
    LOAD_TAX_DETAILS = '[TAX_DETAILS] Load TAX_DETAILS Data Action',
    LOAD_TAX_DETAILS_SUCCESS = '[TAX_DETAILS] Load TAX_DETAILS Data Success Action',
    LOAD_TAX_DETAILS_FAILED = '[TAX_DETAILS] Load TAX_DETAILS Data Fail Action',
    RESET_TAX_DETAILS_DATA = '[TAX_DETAILS] Reset TAX_DETAILS Data Action',
    TAX_DETAILS_FILE_DOWNLOAD_ACTION = '[TAX_DETAILS] File Download Action',
    SET_TAX_DETAILS_DATE_FILTER = '[TAX_DETAILS] Date Filter Action',
    SET_TAX_DETAILS_SORT = '[TAX_DETAILS] Set Tax Details Sort Action',
    SET_TAX_DETAILS_START_END_FINANCIAL_YEAR = '[TAX_DETAILS] Date Start End Financial Year Action',
    TAX_DETAILS_FILE_DOWNLOAD = '[TAX_DETAILS] Tax Details File Download Action',
}


export class LoadTaxDetailsDatesAction implements Action {
    readonly type = ActionTypes.LOAD_TAX_DETAILS_DATES;
    public constructor(public payload: DatesIntervalRequest) {
    }
}

export class LoadTaxDetailsDatesSuccessAction implements Action {
    readonly type = ActionTypes.LOAD_TAX_DETAILS_DATES_SUCCESS;
    public constructor(public payload: DatesInterval) {
    }
}

export class LoadTaxDetailsDatesFailedAction implements Action {
    readonly type = ActionTypes.LOAD_TAX_DETAILS_DATES_FAILED;
    public constructor(public payload: any) {
    }
}


export class SetTaxDetailsYearFilterAction implements Action {
    readonly type = ActionTypes.SET_TAX_DETAILS_YEAR_FILTER;
    public constructor(public payload: number) {
    }
}

export class SetTaxDetailsMonthFilterAction implements Action {
    readonly type = ActionTypes.SET_TAX_DETAILS_MONTH_FILTER;
    public constructor(public payload: number) {
    }
}


export class ResetTaxDetailsDataAction implements Action {
    readonly type = ActionTypes.RESET_TAX_DETAILS_DATA;
}




export class LoadTaxDetailsAction implements Action {
    readonly type = ActionTypes.LOAD_TAX_DETAILS;
    public constructor(public payload: TaxDetailsRequestPayload) {
    }
}

export class LoadTaxDetailsSuccessAction implements Action {
    readonly type = ActionTypes.LOAD_TAX_DETAILS_SUCCESS;
    public constructor(public payload: TaxDetailsDataResponse) {
    }
}

export class LoadTaxDetailsFailedAction implements Action {
    readonly type = ActionTypes.LOAD_TAX_DETAILS_FAILED;
    public constructor(public payload: any) {
    }
}

export class SetTaxDetailsStartEndFinancialYear implements Action {
    readonly type = ActionTypes.SET_TAX_DETAILS_START_END_FINANCIAL_YEAR;
    public constructor(public payload: any) {
    }
}

export class SetTaxDetailsDateFilterAction implements Action {
    readonly type = ActionTypes.SET_TAX_DETAILS_DATE_FILTER;
    public constructor(public payload: any) {
    }
}

export class SetTaxDetailsSortAction implements Action {
    readonly type = ActionTypes.SET_TAX_DETAILS_SORT;

    public constructor(public payload: SortInfo) {
    }
}

export class TaxDetailsFileDownloadAction implements Action {
    readonly type = ActionTypes.TAX_DETAILS_FILE_DOWNLOAD;

    public constructor(public payload: TaxDetailsRequestPayload) {
    }
}


export type Actions =
    LoadTaxDetailsDatesAction |
    LoadTaxDetailsDatesSuccessAction |
    LoadTaxDetailsDatesFailedAction |
    SetTaxDetailsYearFilterAction |
    SetTaxDetailsMonthFilterAction |
    ResetTaxDetailsDataAction |
    LoadTaxDetailsAction |
    LoadTaxDetailsSuccessAction |
    LoadTaxDetailsFailedAction |
    SetTaxDetailsDateFilterAction |
    SetTaxDetailsStartEndFinancialYear;
